<template>
  <a-table
    :dataSource="dataSource"
    :columns="columns"
    :pagination="pagination"
    bordered
  >
    <template #bodyCell="{ column,text,record }">
      <template v-if="column.key === 'time'">
        <p>{{ record.startTime }}~</p>
        <p>{{ record.endTime }}</p>
      </template>
      <template v-if="column.key === 'status'">
        <a-badge
          :color="colorMap[record.status]"
          :text="statusOps[record.status]"
        />
      </template>
      <template v-if="column.key === 'personalCenter'">
        <a-switch :checked="text" @change="e => handleOpenEntry(e, record)" />
      </template>
      <template v-if="column.key === 'actions'">
        <a-button
          type="link"
          size="small"
          @click="handlePreview(record, 'view')"
          >查看</a-button
        >

        <a-button
          type="link"
          size="small"
          :disabled="record.status === 3"
          @click="handlePreview(record)"
          >编辑</a-button
        >

        <a-popconfirm
          v-if="dataSource.length"
          title="确认删除吗?"
          ok-text="确定"
          cancel-text="取消"
          :disabled="record.status === 2"
          @confirm="handleDelete(record)"
        >
          <a-button type="link" :disabled="record.status === 2" size="small">
            删除
          </a-button>
        </a-popconfirm>

        <router-link
          :to="{ name: 'ActiveData', query: { activityId: record.id } }"
        >
          <a-button type="link" size="small">活动数据</a-button>
        </router-link>
        <!-- <router-link
          :to="{
            name: 'EditRecord',
            query: { activityId: record.activityId, id: record.id }
          }"
        >
          <a-button type="link" size="small">中奖记录编辑</a-button>
        </router-link> -->

        <a-button type="link" size="small" @click="generateLink(record)">
          生成web链接
        </a-button>
        <a-button type="link" size="small" @click="generateLink(record, 2)">
          生成APP链接
        </a-button>
        <a-button type="link" size="small" @click="handleCopy(record)">
          复制
        </a-button>
      </template>
    </template>
  </a-table>
</template>

<script>
import { inject, reactive, toRefs } from 'vue'
const columns = [
  {
    title: 'id',
    dataIndex: 'id',
    key: 'id'
  },
  {
    title: '活动名称',
    dataIndex: 'activityName',
    key: 'activityName'
  },
  {
    title: '活动类型',
    dataIndex: 'activityType',
    key: 'activityType',
    width: 100,
    customRender({ text }) {
      const ival = {
        1: '转盘',
        2: '刮刮乐',
        3: '盲盒',
        4: '卡牌'
      }
      return ival[text]
    }
  },
  {
    title: '活动时间',
    dataIndex: 'time',
    key: 'time'
  },
  {
    title: '编辑人',
    dataIndex: 'lastUpdateBy',
    key: 'lastUpdateBy'
  },
  {
    title: '编辑时间',
    dataIndex: 'lastUpdateTime',
    key: 'lastUpdateTime'
  },
  {
    title: '状态',
    dataIndex: 'status',
    key: 'status'
  },
  {
    title: '个人中心入口',
    dataIndex: 'personalCenter',
    key: 'personalCenter',
    width: 120
  },
  {
    title: '操作',
    dataIndex: 'actions',
    key: 'actions'
  }
]
export default {
  setup() {
    const state = reactive({
      columns,
      statusOps: {
        1: '未开始',
        2: '进行中',
        3: '已结束'
      },
      colorMap: {
        1: 'orange',
        2: 'blue',
        3: '#d9d9d9'
      }
    })

    return {
      ...toRefs(state),
      ...toRefs(inject('initData'))
    }
  }
}
</script>
